import _ from "lodash";
import React, { Component } from "react";
import { dp } from "../../../utils/shared.js";
import { slideWidth } from "./OmahaConstants";
import get from "lodash/get";

class StoriesButtonOmaha extends Component {
  setRef = (el) => {
    let module = this.props.story;
    module.overrideStoryName = _.get(this.props, "overrideStoryName", module.name);
    module.currentSlide = this.props.currentSlide;
    module.categoryIcon = this.props.categoryIcon;

    const folderType = get(module, "contents.custom_fields.folder_type.val.value", "story");
   
    let url = `/omaha/stories_story?id=${this.props.story.folder_module_id}`;
    if (folderType !== "story") {
      url = `/omaha/recognition_list?id=${this.props.story.id}`;
    }
    this.props.setRefs(this.props.refIndex, {
      el,
      data: { navLocation: url, module }
    });
  };

  render() {
    const { name, background, tint } = this.props; //icon,
    let backgroundUrl = dp(this.props.screen, background);

    return (
      <div
        ref={(el) => this.setRef(el)}
        style={{
          position: "relative",
          float: "left",
          width: slideWidth,
          height: slideWidth,
          marginTop: 0
        }}
      >
        <div
          style={{
            position: "absolute",
            width: "20.37vw",
            height: "20.37vw",
            marginLeft: 0,
            marginRight: 0,
            left: 0, //this.props.marginLeft,
            top: 0, //this.props.marginTop + "vh",
            backgroundImage: "url(" + backgroundUrl + ")",
            backgroundSize: "cover",
            boxShadow: "3px 3px 20px 0px rgba(0,0,0,0.75)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <div
            style={{
              backgroundColor: tint,
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              opacity: 0.75
            }}
          ></div>
          <div
            style={{
              position: "relative",
              fontSize: "1.3vh",
              fontWeight: "bold",
              width: "80%",
              height: "80%",
              overflowX: "hidden",
              overflowY: "hidden",
              wordBreak: "break-word",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <span>{name.toUpperCase()}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default StoriesButtonOmaha;



// WEBPACK FOOTER //
// ./src/Components/Theme/Omaha/StoriesButtonOmaha.jsx